export default __webpack_public_path__ + "static/media/doc-xml.a2af9bdb.svg";